import React from 'react';
import './experience.scss'
const Experience = () =>
{
	return (
		<div className="experience-block">

			<div className="text-side">
				<h2>The Stay Experience</h2>
				<p>
					Enjoy a peaceful farm stay surrounded by nature. Perfect for weekend getaways, family gatherings, and relaxing away from city life.
				</p>
			</div>

			<div className="features-card">
				<h3>Key Features</h3>

				<div className="feature-item"><span>Property Type</span><strong>2 BHK Farm Stay</strong></div>
				<div className="feature-item"><span>Guests</span><strong>Up to 8 People</strong></div>
				<div className="feature-item"><span>Parking</span><strong>Available</strong></div>
				<div className="feature-item"><span>Outdoor</span><strong>Garden & Open Space</strong></div>
				<div className="feature-item"><span>Location</span><strong>Just 20 min from Solapur</strong></div>
			</div>

		</div>
	);
};

export default Experience;